import React from 'react'
import { Modal } from 'react-bootstrap'
import { CashReconciliationDetail } from '../../../../../Model/cashReconciliationXModel'
import { formatMinorCurrency } from '../../../../../Utils/cashReconciliationMoney'

interface PublishReconciliationModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  submission: CashReconciliationDetail | null
  submitting: boolean
}

const PublishReconciliationModal: React.FC<PublishReconciliationModalProps> = ({
  show,
  onHide,
  onConfirm,
  submission,
  submitting,
}) => {
  if (!submission) return null

  const confirmedDeposit = submission.confirmedCashDepositMinor

  return (
    <Modal
      show={show}
      onHide={submitting ? undefined : onHide}
      centered
      className='bx-publish-reconciliation-modal'
      backdrop={submitting ? 'static' : true}
      keyboard={!submitting}
    >
      <div className='bx-modal__content p-4'>
        <div className='d-flex justify-content-between align-items-start mb-4'>
          <h4 className='bx-modal__title m-0'>Publish station report?</h4>
          <button type='button' className='btn-close' onClick={onHide} disabled={submitting} />
        </div>

        <div className='bx-modal__body'>
          <div className='bx-modal__warning mb-4'>
            <strong>This action is final.</strong>
            <p>
              {confirmedDeposit === 0
                ? 'Publishing will close this report. A zero confirmed deposit will not create a wallet credit.'
                : 'Publishing will close this report and queue the confirmed deposit for credit to the account manager wallet.'}
            </p>
          </div>

          <div className='bx-modal__report-summary mb-4'>
            <div>
              <span>Station</span>
              <strong>{submission.stationName || submission.stationId}</strong>
            </div>
            <div>
              <span>Report date</span>
              <strong>{submission.reportDate}</strong>
            </div>
            <div>
              <span>Confirmed deposit</span>
              <strong>{formatMinorCurrency(confirmedDeposit)}</strong>
            </div>
          </div>

          <div className='bx-modal__actions'>
            <button
              type='button'
              className='bx-modal__cancel'
              onClick={onHide}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type='button'
              className='bx-modal__publish'
              onClick={onConfirm}
              disabled={submitting || confirmedDeposit === null}
            >
              {submitting ? 'Publishing...' : 'Yes, publish report'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PublishReconciliationModal